<template>
  <div ref="moderatorPlayer" class="min-vh-100">
    <b-row align-h="center" align-v="center" :class="moderatorPlayerHeight" class="mt-md-5 mt-lg-5 mt-xl-5 mt-1">
      <b-col cols="12" class="text-center">
        <b-row>
          <b-col v-if="$i18n.locale=='en'">
            <h1 style="    margin-top: 44px;">{{ titleEn }}</h1>
            <h3>{{ subTitleEn }}</h3>
          </b-col>
          <b-col v-if="$i18n.locale=='es'">
            <h1 style="    margin-top: 44px;">{{ titleEs }}</h1>
            <h3>{{ subTitleEs }}</h3>
          </b-col>
          <b-col v-if="$i18n.locale=='cat' ">
            <h1 style="    margin-top: 44px;">{{ titleCat }}</h1>
            <h3>{{ subTitleCat }}</h3>
          </b-col>
        </b-row>
      </b-col>


      <b-col cols="11" sm="11" md="11" lg="11" xl="11"
             align-self="center">
        <b-card no-body class="shadowChat mb-4">
          <b-tabs v-model="tabIndex" content-class="mt-5" fill card  :style="tabIndex === 1 ? '' : 'height: 90vh'">

            <b-tab :title="$t('secretaryTabQuestions')" :title-link-class="linkClass(2)">
              <div>
                <div id="conversation-panel" class="conversation-panel">
                  <div style="cursor: pointer"
                       class="message" v-for="(message, index) in newMessages" v-bind:key="index"
                       v-on:click="markQuestionsAsAnswered(index)"
                       :style="message.isAnswered ? 'background-color: #EF5350' : null">
                    <b>
                      {{ message.name }} ({{message.company}})
                    </b>
                    <br>
                    {{ message.msg }}
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-on:click="countNewMsg = 0" :title-link-class="linkClass(1)">
              <template v-slot:title>
                <label>{{$t('secretaryWebinarTabChatLabel')}}
                  <b-badge v-if="tabIndex !==1 && countNewMsg!==0">
                    {{countNewMsg === 0 ? '' : countNewMsg}}
                  </b-badge>
                </label>
              </template>
              <!-- Moderator -->
              <div id="conversation-panel-moderator"
                   class="conversation-panel"
                   style="height: 30vh;">
                <div
                    class="message" v-for="(message, index) in secretaryMessages"
                    v-bind:key="index">
                  <b>
                    {{ message.name }}
                  </b>
                  <br>
                  {{ message.msg }}
                </div>
              </div>
              <b-row align-h="end">
                <b-col cols="12" sm="9" md="9" lg="8" xl="9">
                  <b-textarea v-model="messageSend.msg" v-on:keyup.enter="sendMessage">

                  </b-textarea>
                </b-col>
                <b-col align-self="center" class="mt-md-2 mt-2 mt-lg-0 mt-xl-0" cols="12" sm="3"
                       md="3"
                       lg="3" xl="3">
                  <b-button variant="light" v-on:click="sendMessage">
                    {{ $t('playerBtnSendMessage') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import app from "@/firebaseConfig/config";

export default {
  name: "moderatorPlayer",
  data: () => {
    return {
      secretaryMessages: [],
      tabIndex: 0,
      messageSend: {
        name: '',
        msg: '',
        date: '',
        email: '',
        company: ''
      },
      moderatorPlayerHeight: 'moderatorPlayerHeight',
      newMessages: [],
      countNewMsg: 0,
      periodistesRef: null,
      chatsRef: null
    }
  },
  methods: {
    /**
     * active or deactivate tabs
     * @param idx
     */
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-light', 'text-dark']
      } else {
        return ['', 'text-dark']
      }
    },
    /**
     * Send msg to moderator
     */
    sendMessage() {
      //function to push message to firebase and if you are not admin inserts in chat
      const d = new Date;
      this.messageSend.date = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()
      this.messageSend.date = this.messageSend.date.toString()
      if (this.messageSend.msg[this.messageSend.msg.length - 1] === '\n') {
        this.messageSend.msg = this.messageSend.msg.slice(0, -1)
      }
      this.chatsModeratorRef.push(this.messageSend)
      this.messageSend.msg = ''
      this.messageSend.date = ''
      setTimeout(function () {
        const conversationPanel = document.getElementById('conversation-panel');
        conversationPanel.scrollTop = conversationPanel.clientHeight;
        conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
      }, 100)
    },
    /**
     * Get cookie passed by param
     * @param cname
     * @returns {string}
     */
    getCookie(cname) {
      //function that passes the key of the cookie to obtain the value
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    /**
     * Delete cookie passed by param
     * @param name
     */
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    newSecretaryMessage(snapshot) {
      const newPost = snapshot.val();
      this.countNewMsg++

      this.secretaryMessages.push({
        name: newPost.name,
        email: newPost.email,
        msg: newPost.msg,
        date: newPost.date
      })

      setTimeout(() => {
        try {
          const conversationPanel = document.getElementById('conversation-panel-moderator');
          conversationPanel.scrollTop = conversationPanel.clientHeight;
          conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
        } catch (e) {
          console.log()
        }
      }, 200)
    },
    markQuestionsAsAnswered(index) {
      const code = this.code
      const msgUpdate = this.newMessages[index]

      msgUpdate.isAnswered = true
      this.$set(this.newMessages, index, msgUpdate)
      this.chatsRef.orderByChild('date').equalTo(msgUpdate.date).once('value', function (snapshot) {

        snapshot.forEach(function (childSnapshot) {
          const key = childSnapshot.key
          const childData = childSnapshot.val();
          if (msgUpdate.email === childData.email && msgUpdate.msg === childData.msg) {
            const updateMessageRef = app.database().ref(`lallucana/${code}/msg/${key}`)
            updateMessageRef.update(msgUpdate)
          }
        });
      })

    },
    filteredQuestions(snapshot) {
      try {
        const newPost = snapshot.val()
        if (newPost.filtered && !newPost.isAnswered) {
          this.newMessages.push({
            name: newPost.name,
            email: newPost.email,
            msg: newPost.msg,
            company: newPost.company,
            date: newPost.date,
            filtered: newPost.filtered,
            isAnswered: newPost.isAnswered
          })
          //There's a delay between firebase and user, that's why I execute this setTimeout
          setTimeout(() => {
            try {
              const conversationPanel = document.getElementById('conversation-panel');
              conversationPanel.scrollTop = conversationPanel.clientHeight;
              conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
            } catch (e) {
              console.log()
            }
          }, 200)
        } else {
          throw Error
        }
      } catch (e) {
        snapshot.forEach(childSnapshot => {
          const newPost = childSnapshot.val()
          if (newPost.filtered) {
            this.newMessages.push({
              name: newPost.name,
              email: newPost.email,
              msg: newPost.msg,
              date: newPost.date,
              company: newPost.company,
              filtered: newPost.filtered,
              isAnswered: newPost.isAnswered? newPost.isAnswered : false
            })
            //There's a delay between firebase and user, that's why I execute this setTimeout
            setTimeout(() => {
              try {
                const conversationPanel = document.getElementById('conversation-panel');
                conversationPanel.scrollTop = conversationPanel.clientHeight;
                conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
              } catch (e) {
                console.log()
              }
            }, 200)
          }
        })
      }
    },
    /**
     * Verify Height of user widow for make page more responsive
     */
    matchHeight() {
      const totalComponentsHeight = this.$refs.moderatorPlayer.clientHeight + 87 + 100
      document.documentElement.clientHeight <= 890 ? this.moderatorPlayerHeight = 'min-vh-100' : this.moderatorPlayerHeight = 'moderatorPlayerHeight'
      if (totalComponentsHeight < document.documentElement.clientHeight) {
        if (this.footerClass !== 'footer') this.$store.commit('updateFooterClass', 'footer')
      } else {
        if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
      }
    },
  },
  created() {
    try {
      this.code = this.$route.params.id ? this.$route.params.id : localStorage.getItem('code')
      this.chatsRef = app.database().ref(`lallucana/${this.code}/msg`)
      this.periodistesRef = app.database().ref(`lallucana/${this.code}/periodistes`)
      this.usersRef = app.database().ref(`lallucana/${this.code}/users`)
      this.chatsModeratorRef = app.database().ref(`lallucana/${this.code}/moderator/msg`)
      //deleteAdminCookie
      this.deleteCookie('adminUser')
      this.titleEn = localStorage.getItem('webinarTitleEn')
      this.titleEs = localStorage.getItem('webinarTitleEs')
      this.titleCat = localStorage.getItem('webinarTitleCat')
      this.subTitle = localStorage.getItem('webinarSubTitle')
      this.subTitleEs = localStorage.getItem('webinarSubTitleEs')
      this.subTitleCat = localStorage.getItem('webinarSubTitleCat')
      this.messageSend.name = this.getCookie('name')
      this.messageSend.email = this.getCookie('email')
    } catch (e) {
      console.log(e)
      this.$router.push({path: '/'})
    }
    //Verify is cookie exist or not
    if (!document.cookie) {
      this.$router.push({path: '/'})
    } else {
      this.messageSend.name = this.getCookie('name')
      this.messageSend.email = this.getCookie('email')
    }
  },
  mounted() {
    this.matchHeight()
    window.addEventListener("resize", this.matchHeight);

    //Count total users connected in the conference
    //function for receive the new messages added in firebase
    this.chatsRef.on("child_changed", this.filteredQuestions)
    this.chatsRef.once("value", this.filteredQuestions)
    this.periodistesRef.on("child_changed", this.filteredQuestions)
    this.periodistesRef.once("value", this.filteredQuestions)
    //function for receive the new messages added in firebase from moderator or to moderator
    this.chatsModeratorRef.on("child_added", this.newSecretaryMessage)

  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  }
}
</script>

<style scoped>
.moderatorPlayerHeight {
  height: 82vh;
}

.conversation-panel {
  margin-bottom: 20px;
  text-align: left;
  max-height: 400px;
  overflow: auto;
  width: 100%;
}
button {
  background-color: #5f579A ;
  color: white;
}
button:hover {
  color: white;
  background-color: #5f579A ;

}
</style>
